import { translator } from './I18n';

export default class Utils {
  static requestHelper = function(requestOptions = {}) {
    const formattedOptions = {
      method: requestOptions.type,
      url: requestOptions.url,
      withCredentials: true
    };
    if (requestOptions.type === 'POST') {
      formattedOptions.headers = {
        'Content-Type': 'application/json'
      };

      const tokenElement = document.querySelector('[name="csrf-token"]');
      const token = tokenElement && tokenElement.content;
      if (token) {
        formattedOptions.headers['X-CSRF-TOKEN'] = token;
      }

      formattedOptions.data = requestOptions.data;
    }

    axios(formattedOptions)
      .then(function (response) {
        // Request was a success :)
        if (!requestOptions.success) return;

        requestOptions.success(response.data);
      })
      .catch(function (error) {
        // We reached our target server, but it returned an error
        if (!requestOptions.error) return;

        requestOptions.error(error.response);
      });
  }

  static loadInitialReactData(url, callback_func, error_callback) {
    return this.requestHelper({
      type: 'GET',
      url,
      success: function(data) {
        return callback_func(data);
      },
      error: function(data) {
        return error_callback(data);
      }
    });
  }

  static getAllAcademicYears = () => [
    translator.t('basic.years.seventh'),
    translator.t('basic.years.eighth'),
    translator.t('basic.years.fresh'),
    translator.t('basic.years.soph'),
    translator.t('basic.years.junior'),
    translator.t('basic.years.senior')
  ];

  static allExamNames = () => [
    translator.t('basic.exams.pre_alg'),
    translator.t('basic.exams.alg_one'),
    translator.t('basic.exams.geo'),
    translator.t('basic.exams.alg_two'),
    translator.t('basic.exams.pre_calc'),
    translator.t('basic.exams.calc')
  ];

  static getPackageForTier = (tier) => {
    const PACKAGES = [
      translator.t('basic.package_a.title'),
      translator.t('basic.package_b.title'),
      translator.t('basic.package_c.title')
    ];
    return PACKAGES[tier - 1];
  }

  // helper function that takes in an integer and returns a translated term for it
  static getTerm = function(term_as_int) {
    const TERMS = [
      translator.t('basic.spring'),
      translator.t('basic.fall')
    ];
    return TERMS[term_as_int];
  }

  // helper function that takes in an integer and returns the exam_name for it.
  // example: getExamName(1) will return "Algebra I"
  static getExamName = function(exam_level) {
    const allExamNames = this.allExamNames();
    return allExamNames[exam_level];
  }

  static getExamLevel = function(exam_name) {
    const allExamNames = this.allExamNames();
    return allExamNames.indexOf(exam_name);
  }

  // helper function that takes in an integer and returns the academic year for it.
  // example: getAcademicYear(1) will return 'Seventh Grade'
  static getAcademicYear = function(year_level) {
    const academic_years = this.getAllAcademicYears();
    return academic_years[year_level];
  };

  // function that takes in an object and returns the object's full name
  static getFullName = function(object) {
    if (object) {
      return `${ object.first_name } ${ object.last_name }`;
    } else {
      return '-';
    }
  };

  // function that takes in an array of grades and returns if all grades have
  // been submitted
  static allGradesPresent = function(grades, numberActiveStudents) {
    return grades.length === numberActiveStudents;
  }

  // function that filters a student based on a filter term
  static fitsSearchTerm = function(student, term) {
    term = term.toLowerCase();
    const first = student.first_name.toLowerCase();
    const last = student.last_name.toLowerCase();

    const first_name_match = first.indexOf(term) !== -1;
    const last_name_match = last.indexOf(term) !== -1;
    const combo_match = `${first} ${last}`.indexOf(term) !== -1;

    return first_name_match || last_name_match || combo_match || (term === '');
  };

  // function that filters a student based on exam_level
  static filterByExamLevel = function(student, exam_level) {
    return student.exam_level === exam_level;
  };

  // function that filters a student based on active_live_exam
  static filterByActiveLiveExam = function(student, default_selected_student_id) {
    return (student.active_live_exam === 0) || (student.id === default_selected_student_id);
  }

  static delayedRedirect = function(location, time = 1500) {
    return setTimeout(( () => window.location = location), time);
  };

  static showNotification = function(message, type) {
    new Noty({
      type,
      layout: 'topRight',
      theme: 'semanticui',
      text: message,
      closeWith: [
        'click',
        'button'
      ],
      animation: {
        open: 'noty_effects_open',
        close: 'noty_effects_close'
      }
    }).show();
  }

  static setPageUrl = function(base_url, params, view) {
    const url = params ? `${base_url}${params}` : '';

    if (url && history.pushState) {
      return history.pushState({ view }, document.title, url);
    }
  };

  static verifyTrue = value => ['true', true].indexOf(value) !== -1;

  static verifyFalse = value => ['false', false].indexOf(value) !== -1;

  static groupBy = function(data, key) {
    return data.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  static t = function(key, parameters = {}) {
    return translator.t(key, parameters);
  }

  static strftime = function(date, format) {
    return translator.strftime(date, format);
  }
}
